var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    transform: "translate(0 17)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.201,
    y: 0.707031,
    width: 56,
    height: 56,
    rx: 12,
    transform: "rotate(15 18.201 0.707031)",
    fill: "#41A8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_43161_805)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 17,
    width: 56,
    height: 56,
    rx: 12,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 17.5,
    width: 55,
    height: 55,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6667 42.6668H16.3333M39.6667 43.8335V40.5668C39.6667 39.26 39.6667 38.6066 39.4123 38.1075C39.1886 37.6685 38.8317 37.3115 38.3926 37.0878C37.8935 36.8335 37.2401 36.8335 35.9333 36.8335H20.0667C18.7599 36.8335 18.1065 36.8335 17.6074 37.0878C17.1683 37.3115 16.8114 37.6685 16.5876 38.1075C16.3333 38.6066 16.3333 39.26 16.3333 40.5668V49.4335C16.3333 50.7403 16.3333 51.3937 16.5876 51.8928C16.8114 52.3318 17.1683 52.6888 17.6074 52.9125C18.1065 53.1668 18.7599 53.1668 20.0667 53.1668H27.4167M35 55.5002C35 55.5002 38.5 53.8319 38.5 51.3296V48.4102L35.9478 47.4982C35.3346 47.2786 34.664 47.2786 34.0508 47.4982L31.5 48.4102V51.3296C31.5 53.8319 35 55.5002 35 55.5002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_43161_805",
    x: -16,
    y: 1,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_43161_805"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_43161_805",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.c72eae04ae48f7f1292b4853177a9bcf.svg";
export { ForwardRef as ReactComponent };